package io.horion.auth.api.services

import kotlinx.serialization.Serializable

@Serializable
data class Error(val error: String)